import React from 'react';
import { styled } from '@mui/material/styles';
import {
  Box,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import Sidebar from './Sidebar';
import Header from './components/Header';
import Footer from './components/Footer';
import { useTranslation } from 'react-i18next';
import { BRAND_GRADIENTS } from '../../config/brand';

// Stil tanımlamaları
const PageContainer = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  background: BRAND_GRADIENTS.vertical, // BRAND'den
  position: 'relative',
  padding: 0,
  overflow: 'hidden',
}));

const ContentWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  width: '100%',
  height: 'calc(100vh - 64px)',
  overflow: 'hidden',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column-reverse',
    height: 'auto',
    overflow: 'auto',
  },
}));

const SidebarContainer = styled(Box)(({ theme }) => ({
  width: 320,
  height: '100%',
  position: 'sticky',
  top: 0,
  padding: theme.spacing(2),
  overflowY: 'auto',
  flexShrink: 0,
  [theme.breakpoints.down('md')]: {
    width: '100%',
    position: 'relative',
    height: 'auto',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    overflowY: 'visible',
  },
}));

const MainContent = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  paddingBottom: theme.spacing(8),
  overflowY: 'auto',
  height: '100%',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2, 1),
    paddingBottom: theme.spacing(8),
    height: 'calc(100vh - 200px)',
    maxHeight: '100%',
    overflowY: 'auto',
  },
}));


interface FeaturePageProps {
  title: string;
  children?: React.ReactNode;
}

const FeaturePageTemplate: React.FC<FeaturePageProps> = ({ title, children }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <PageContainer>
      <Header />

      <ContentWrapper>
        <SidebarContainer>
          <Sidebar mobile={isMobile} />
        </SidebarContainer>
        
        <MainContent>
          <Typography 
            variant="h3" 
            component="h1" 
            gutterBottom 
            sx={{ 
              color: 'white', 
              fontWeight: 700, 
              mb: 5, 
              textAlign: 'center',
              fontSize: { xs: '2rem', md: '2.5rem' }
            }}
          >
            {title}
          </Typography>
          
          {children || (
            <Typography 
              variant="body1" 
              sx={{ 
                color: 'white', 
                textAlign: 'center', 
                p: 4, 
                backgroundColor: 'rgba(255, 255, 255, 0.1)', 
                borderRadius: 2 
              }}
            >
              Bu özellik hakkında detaylı içerik yakında eklenecektir.
            </Typography>
          )}
          <Footer />
        </MainContent>
      </ContentWrapper>
    </PageContainer>
  );
};

export default FeaturePageTemplate; 